module.exports = __webpack_public_path__ + "img/1446951034.8a5d5b19.jpg";